import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import OfferCard from "@/components/offers/OfferCard";
import api from "@/lib/api";

export default function CandidateFavoritesTab() {
  const { t } = useTranslation();
  const [favorites, setFavorites] = useState(null);

  useEffect(() => {
    api.get("/favorites/me").then(({ data }) => setFavorites(data.filter((f) => f.target_type === "offer")));
  }, []);

  if (!favorites) return <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#4ba3b7]" /></div>;

  return (
    <div data-testid="candidate-favorites-tab">
      {favorites.length === 0 ? (
        <p className="text-center py-16 text-[#2B2B2B]/50" data-testid="candidate-favorites-empty-message">{t("search.noResults")}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {favorites.filter((f) => f.offer).map((f) => <OfferCard key={f.target_id} offer={f.offer} />)}
        </div>
      )}
    </div>
  );
}
